"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPatientPartialInput = instanceOfPatientPartialInput;
exports.PatientPartialInputFromJSON = PatientPartialInputFromJSON;
exports.PatientPartialInputFromJSONTyped = PatientPartialInputFromJSONTyped;
exports.PatientPartialInputToJSON = PatientPartialInputToJSON;
/**
 * Check if a given object implements the PatientPartialInput interface.
 */
function instanceOfPatientPartialInput(value) {
    if (!('ssn' in value) || value['ssn'] === undefined)
        return false;
    return true;
}
function PatientPartialInputFromJSON(json) {
    return PatientPartialInputFromJSONTyped(json, false);
}
function PatientPartialInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ssn': json['ssn'],
    };
}
function PatientPartialInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'ssn': value['ssn'],
    };
}
